import {
  CarDisclosureContentCode,
  UseDisclosures,
} from "@app/hooks/useDisclosures";
import { PdfReportPage, PdfReportPageProps } from "./PdfReportPage";
import { CarPdfHeading } from "@app/components/PdfHeading";
import { CarPdfMarkdown } from "@app/components/PdfMarkdown";

export interface GlossaryPdfPageProps {
  disclosures: UseDisclosures;
  pageProps: PdfReportPageProps;
}

export const GlossaryPdfPage = (props: GlossaryPdfPageProps) => (
  <PdfReportPage {...props.pageProps}>
    <CarPdfHeading label="Glossary" style={{ marginBottom: 14 }} />
    <CarPdfMarkdown>
      {props.disclosures.getContent(
        CarDisclosureContentCode.CMPAS_CLIENT_REPORT_GLOSSARY_part_100,
      )}
    </CarPdfMarkdown>
  </PdfReportPage>
);
